
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    preheading: {
      type: String,
      default: ''
    },
    heading: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    button: {
      type: String,
      default: ''
    }
  },
  mounted() {
    if (this.show) {
      this.$nextTick(() => {
        const popup = this.$refs.popup
        if (popup) {
          popup.focus()
        }
        document.addEventListener('keydown', this.trapFocus)
        // Scroll to top when popup opens
        // window.scrollTo(0, 0)
      })
    }
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.trapFocus)
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          const popup = this.$refs.popup
          if (popup) {
            popup.focus()
          }
          document.addEventListener('keydown', this.trapFocus)
          // window.scrollTo(0, 0)
        })
      } else {
        document.removeEventListener('keydown', this.trapFocus)
      }
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    handleAction() {
      this.$emit('action')
    },
    trapFocus(e) {
      if (!this.show) return

      const focusableElements = this.$refs.popup.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
      const firstFocusableElement = focusableElements[0]
      const lastFocusableElement = focusableElements[focusableElements.length - 1]

      if (e.key === 'Tab') {
        if (e.shiftKey) /* shift + tab */ {
          if (document.activeElement === firstFocusableElement) {
            e.preventDefault()
            lastFocusableElement.focus()
          }
        } else /* tab */ {
          if (document.activeElement === lastFocusableElement) {
            e.preventDefault()
            firstFocusableElement.focus()
          }
        }
      }

      if (e.key === 'Escape') {
        this.close()
      }
    }
  }
}
